import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

interface CTASectionProps {
  onEstimateClick: () => void;
}

export default function CTASection({ onEstimateClick }: CTASectionProps) {
  const { ref, visible } = useScrollAnimation();

  return (
    <section id="contact" className="relative py-28 sm:py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://downsconstructionllc.com/images/finalhomeimg-850w.jpeg"
          alt="home renovation project"
          className="w-full h-full object-cover object-top"
          loading="lazy"
          decoding="async"
        />
      </div>
      {/* Navy-tinted Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary-dark/90 via-primary/80 to-primary-dark/85"></div>
      {/* Decorative pattern */}
      <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'repeating-linear-gradient(45deg, #fff 0, #fff 1px, transparent 0, transparent 50%)' , backgroundSize: '20px 20px' }}></div>

      <div
        ref={ref}
        className={`relative z-10 max-w-3xl mx-auto px-6 sm:px-8 text-center transition-all duration-700 ease-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        <div className="inline-flex items-center gap-2 mb-5">
          <div className="w-8 h-px bg-primary-light/60"></div>
          <span className="text-primary-light text-xs font-bold uppercase tracking-[0.3em]">Get Started Today</span>
          <div className="w-8 h-px bg-primary-light/60"></div>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-6xl font-black uppercase text-white leading-tight mb-5" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
          Let&apos;s Build Something Great Together
        </h2>
        <p className="text-blue-100/80 text-sm sm:text-base leading-relaxed mb-10 max-w-xl mx-auto">
          Have a vision for your home or property? Contact us today to schedule your free estimate and take the first step toward lasting quality.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={onEstimateClick}
            className="bg-white hover:bg-primary-light text-primary text-sm font-bold uppercase tracking-widest px-10 py-4 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap btn-press"
          >
            Request a Free Estimate
          </button>
          <a
            href="tel:269-599-4913"
            className="border-2 border-white/60 hover:border-white text-white hover:bg-white/10 text-sm font-bold uppercase tracking-widest px-8 py-4 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 btn-press"
          >
            <i className="ri-phone-line"></i>
            (269) 599-4913
          </a>
        </div>
      </div>
    </section>
  );
}
